import classNames from "classnames";
import React, { ReactElement } from "react";
import styles from "./navbar.module.scss";

const CoinIcon = (props: Props): ReactElement => {
  return (
    <div className={styles.coinIcon}>
      <CoinBaseIcon state={props.state} />
      <CoinCreditIcon
        state={props.state}
        credit={props.state == CoinIconState.UNLIMITED ? "∞" : props.credit}
      />
    </div>
  );
};

interface Props {
  state: CoinIconState;
  credit: number;
}

export enum CoinIconState {
  LOGGEDOUT = "loggedout",
  UNLIMITED = "unlimited",
  HASPACKAGE = "haspackage",
  HASPACKAGENOCREDIT = "haspackagenocredit",
  NOPACKAGE = "nopackage",
  FREEMIUM = "freemium",
}

export const CoinBaseIcon = (props: {
  state: CoinIconState;
  size?: number;
}) => {
  return (
    <svg
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: props.size, height: props.size }}
    >
      <circle
        cx="20.5"
        cy="20.5"
        r="20"
        fill={
          [CoinIconState.NOPACKAGE, CoinIconState.HASPACKAGENOCREDIT].indexOf(
            props.state
          ) > -1
            ? "#BAC3C3"
            : "#2B81FC"
        }
      />
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5151 14.4849C20.059 13.941 20.9409 13.941 21.4849 14.4849L26.9018 19.9018C27.4458 20.4458 27.4458 21.3277 26.9018 21.8716L21.4849 27.2886C20.9409 27.8325 20.059 27.8325 19.5151 27.2886L14.0981 21.8716C13.5542 21.3277 13.5542 20.4458 14.0981 19.9018L19.5151 14.4849Z"
        fill={
          [CoinIconState.NOPACKAGE, CoinIconState.HASPACKAGENOCREDIT].indexOf(
            props.state
          ) > -1
            ? "#747B7B"
            : "#2C5A97"
        }
      />
    </svg>
  );
};

export const CoinCreditIcon = (props) => {
  return (
    <div
      className={classNames(props.className, styles.creditIcon, {
        [styles.noCreditGray]:
          [CoinIconState.NOPACKAGE, CoinIconState.HASPACKAGENOCREDIT].indexOf(
            props.state
          ) > -1,
        [styles.unlimitedFontSize]: props.state == CoinIconState.UNLIMITED,
      })}
    >
      {props.credit}
    </div>
  );
};

export default CoinIcon;
